<template>
  <b-card class="border-0 transparent">
    <b-row>
      <!-- kundenavne -->
      <b-col md="2" lg="2">
        <b-row style="height:36px;" class="bg-dark text-white mb-4">
          <b-col class="pt-2 mb-4">
            <p class="d-inline-flex font-weight-bold">Kundenavn</p>
          </b-col>
        </b-row>
        <b-row v-for="status in status" :key="status.id" class="p-0 m-0" style="height:36px;line-height:36px;">
          <p class="font-weight-bold w-100">{{ status.kunde.name }}</p>
        </b-row>
      </b-col>
      <!-- info om projektet indtastet -->
      <b-col>
        <b-row style="height:36px;" class="bg-dark mb-4 pt-2 text-center">
          <b-col class="text-warning font-weight-bold w-100">
            <p>
              <span class="mr-2">Indtastet</span>
              <span v-b-tooltip.hover title="Håndværkeren har indtastet informationerne om projektet, herunder også kundens kontaktinfo.">
                <span class="el-icon-question" style="position:relative;top:2px;"></span>
              </span>
            </p>
          </b-col>
        </b-row>
        <b-row v-for="status in status" :key="status.id" class="p-0 m-0 text-center" style="height:48px;">
          <template>
            <span v-if="status.emailcustomer !== '0'" class="mx-auto">
             <span class="el-icon-success text-success"></span>
            </span>
            <span v-else class="mx-auto">
              <span class="el-icon-error"></span>
            </span>
          </template>
        </b-row>
      </b-col>
      <!-- tilladelse -->
      <b-col>
        <b-row style="height:36px;" class="bg-dark mb-4 pt-2 text-center">
          <b-col class="text-warning font-weight-bold w-100">
            <p>
              <span class="mr-2">Tilladelse</span>
              <span v-b-tooltip.hover title="Kunden er blevet informeret om projektet og har givet tilladelse til billedtagning mm.">
                <span class="el-icon-question" style="position:relative;top:2px;"></span>
              </span>
            </p>
          </b-col>
        </b-row>
        <b-row v-for="status in status" :key="status.id" class="p-0 m-0 text-center" style="height:48px;">
          <template>
            <span v-if="status.acceptcustomer !== '0'" class="mx-auto">
             <span class="el-icon-success text-success"></span>
            </span>
            <span v-else class="mx-auto">
              <span class="el-icon-error"></span>
            </span>
          </template>
        </b-row>
      </b-col>
      <!-- fotografering -->
      <b-col>
        <b-row style="height:36px;" class="bg-dark mb-4 pt-2 text-center">
          <b-col class="text-warning font-weight-bold w-100">
            <p>
              <span class="mr-2">Foto</span>
              <span v-b-tooltip.hover title="Fotografen har været ude hos kunden og har taget billeder af projektet.">
                <span class="el-icon-question" style="position:relative;top:2px;"></span>
              </span>
            </p>
          </b-col>
        </b-row>
        <b-row v-for="status in status" :key="status.id" class="p-0 m-0 text-center" style="height:48px;">
          <template>
            <span v-if="status.esoft !== '0'" class="mx-auto">
             <span class="el-icon-success text-success"></span>
            </span>
            <span v-else class="mx-auto">
              <span class="el-icon-error"></span>
            </span>
          </template>
        </b-row>
      </b-col>
      <!-- kvalitetssikring og redigering -->
      <b-col>
        <b-row style="height:36px;" class="bg-dark mb-4 pt-2 text-center">
          <b-col class="text-warning font-weight-bold w-100">
            <p>
              <span class="mr-2">Redigering</span>
              <span v-b-tooltip.hover title="Billederne af projektet er blevet gennemgået og godkendt, og tekst til projektet er blevet skrevet.">
                <span class="el-icon-question" style="position:relative;top:2px;"></span>
              </span>
            </p>
          </b-col>
        </b-row>
        <b-row v-for="status in status" :key="status.id" class="p-0 m-0 text-center" style="height:48px;">
          <template>
            <span v-if="status.online !== '0'" class="mx-auto">
             <span class="el-icon-success text-success"></span>
            </span>
            <span v-else class="mx-auto">
              <span class="el-icon-error"></span>
            </span>
          </template>
        </b-row>
      </b-col>
      <!-- offentligjort -->
      <b-col>
        <b-row style="height:36px;" class="bg-dark mb-4 pt-2 text-center">
          <b-col class="text-warning font-weight-bold w-100">
            <p>
              <span class="mr-2">Lanceret</span>
              <span v-b-tooltip.hover title="Projektet er blevet offentliggjort på håndværker.dk">
                <span class="el-icon-question" style="position:relative;top:2px;"></span>
              </span>
            </p>
          </b-col>
        </b-row>
        <b-row v-for="status in status" :key="status.id" class="p-0 m-0 text-center" style="height:48px;">
          <template>
            <span v-if="status.online !== '0'" class="mx-auto">
             <span class="el-icon-success text-success"></span>
            </span>
            <span v-else class="mx-auto">
              <span class="el-icon-error"></span>
            </span>
          </template>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
export default {
  name: 'statuslist',
  data () {
    return {
      status: [ ]
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    var data = {operation: 'myProject', salesPerson: this.salesPerson, levid: this.haaId}
    this.$http.post('', data, { emulateJSON: true })
      .then(
        response => {
          var res = response.body
          if (res.login === false) {
            this.$router.push('/login')
          }
          this.status = res
        },
        response => {
          alert('error')
        }
      )
  }
}
</script>
<style scoped>
.row > .align-items-center > .col {
  height: 24px;
  line-height: 24px!important;
}
.p-0.m-0.rowHeightFix.container > div > div.col-12 > div > div.col-4 > div > div {
  height: 24px;
  line-height: 24px!important;
}
.main .container-fluid {
  padding: 15px 0;
}
.initialism {
  text-transform: none;
}
.fa-question-circle {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// NewStatusList.vue?044fb4da